import { sortBySequenceNumber } from 'shared/lib/common-util'
import { fromDocumentResponse } from '../../document/models/responseToModel'
import { DocumentUpdate } from '../../document/models/request'
import { Document } from '../../document/models/types'
import { toUpdateDocumentRequests } from '../models/mapper'
import { updateConsignmentDocumentsV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function updateConsignmentDocuments(
  transitOperationId: number,
  consignmentId: number,
  documents: DocumentUpdate[],
): Promise<Document[]> {
  const requests = toUpdateDocumentRequests(documents, transitOperationId, consignmentId)
  if (requests.length === 0) {
    return []
  }

  const responses = await updateConsignmentDocumentsV3(consignmentId, requests)
  return responses.map((r, i) => fromDocumentResponse(r, i)).sort(sortBySequenceNumber)
}
